import React, { useState } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

/**
 * CommonTextField component that wraps the MUI TextField
 * and allows you to reuse the same component with consistent props.
 */
const CommonTextField = ({ label, value, onChange, name, error = false, helperText = '', sx, type = 'text', ...props }) => {
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  // Define input type, default to 'text' or 'password'
  const inputType = type === 'password' ? !showPassword ? 'password' : 'text':type;

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      name={name}
      error={error}
      helperText={helperText}
      fullWidth
      margin="normal"
      type={inputType||type} // Set type dynamically based on state
      sx={sx} // You can pass custom styles here
      slotProps={{
        inputLabel: {
          shrink: true, // Ensures the label stays shrunk
        },
        input:{
          endAdornment:
          type === 'password' && (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }
      }}
 
      {...props} // Spread the remaining props to TextField
    />
  );
};

export default CommonTextField;
